module.exports = __webpack_public_path__ + "img/aggregate.dbe17541.svg";